import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing available tacho icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AvailableTachoIcon width={12} />
 */
function OtherWorkTachoIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d={`M36.5,18.25l-8.92,8.92L42,41.63l-3.71,3.71L23.86,30.88,9.4,45.35,5.68,41.63,
            20.15,27.17l-8.78-8.78L3,26.75V14.87L14.88,3l5.94,5.94-5.74,5.74,8.78,8.78,8.92-8.92-5.6-5.6L33.12,
            3,45,14.87V26.75Z`}
            />
        </SvgIcon>
    )
}

OtherWorkTachoIcon.defaultProps = defaultProps

export { OtherWorkTachoIcon }
